import AttendanceList from './Attendance';

export default {
    list: AttendanceList,
};

export * from './AttendanceListGroup';
export * from './AttendanceListGroupEditable';